var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "104px",
    viewBox: "0 0 84 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-bin-2034046") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-15.8%",
    y: "-12.5%",
    width: "131.6%",
    height: "125.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-bin-2034046",
    transform: "translate(4.000000, 2.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6,7.5 L51.6,7.5 L51.6,7.3 C51.6,3.5 48.6,0.5 44.8,0.5 L31.2,0.5 C27.4,0.5 24.4,3.5 24.4,7.3 L24.4,7.5 L4.4,7.5 C2.3,7.5 0.6,9.2 0.6,11.3 L0.6,15.1 C0.6,17.2 2.3,18.9 4.4,18.9 L71.6,18.9 C73.7,18.9 75.4,17.2 75.4,15.1 L75.4,11.3 C75.4,9.2 73.7,7.5 71.6,7.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6,24.1 L9.4,24.1 C8.3,24.1 7.5,25 7.6,26.1 L10.4,84 C10.7,90.4 16,95.5 22.4,95.5 L53.5,95.5 C59.9,95.5 65.2,90.5 65.5,84 L68.3,26.1 C68.5,25.1 67.6,24.1 66.6,24.1 Z M31.8,80 C31.8,81.8 30.4,83.2 28.6,83.2 C26.8,83.2 25.4,81.8 25.4,80 L25.4,39.7 C25.4,37.9 26.8,36.5 28.6,36.5 C30.4,36.5 31.8,37.9 31.8,39.7 L31.8,80 Z M50.6,80 C50.6,81.8 49.2,83.2 47.4,83.2 C45.6,83.2 44.2,81.8 44.2,80 L44.2,39.7 C44.2,37.9 45.6,36.5 47.4,36.5 C49.2,36.5 50.6,37.9 50.6,39.7 L50.6,80 Z",
    id: "Shape",
    stroke: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.dd333a73164f65adb23935736c3145f7.svg";
export { ForwardRef as ReactComponent };